import { Box, Card, CardContent, LinearProgress, Stack, Typography } from '@mui/material'
import { ISingleDocument } from '@typings'
import { formatValueToCurrency } from 'src/utilities/helpers/formatCentToAmount.helper'
import { PAYMENT_LABELS } from 'src/constants/payment.constants'

interface PaymentSummaryProps {
  document: ISingleDocument
}

export const PaymentSummary = ({ document }: PaymentSummaryProps) => {
  const { total, paid_amount, outstanding_amount } = document
  const paidPercentage = total > 0 ? (paid_amount / total) * 100 : 0

  const getStatusLabel = () => {
    if (paid_amount >= total) {
      return PAYMENT_LABELS.PAID
    }
    if (paid_amount > 0) {
      return PAYMENT_LABELS.PARTIAL
    }
    return PAYMENT_LABELS.OUTSTANDING
  }

  const getStatusColor = () => {
    if (paid_amount >= total) {
      return 'success.main'
    }
    if (paid_amount > 0) {
      return 'warning.main'
    }
    return 'error.main'
  }

  return (
    <Card>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom>
          Betalingsstatus
        </Typography>

        <Stack spacing={2}>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ mb: 0.5 }}>
              <Typography variant="body2">Totaal</Typography>
              <Typography variant="body2">{formatValueToCurrency(total)}</Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ mb: 0.5 }}>
              <Typography variant="body2">Betaald</Typography>
              <Typography
                variant="body2"
                color="success.main">
                {formatValueToCurrency(paid_amount)}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between">
              <Typography
                variant="body2"
                fontWeight={600}>
                Openstaand
              </Typography>
              <Typography
                variant="body2"
                fontWeight={600}
                color={getStatusColor()}>
                {formatValueToCurrency(outstanding_amount)}
              </Typography>
            </Stack>
          </Box>

          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1 }}>
              <Typography
                variant="caption"
                color="text.secondary">
                {getStatusLabel()}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary">
                {paidPercentage.toFixed(0)}%
              </Typography>
            </Stack>
            <LinearProgress
              variant="determinate"
              value={paidPercentage}
              color={paid_amount >= total ? 'success' : paid_amount > 0 ? 'warning' : 'error'}
              sx={{ height: 8, borderRadius: 4 }}
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  )
}
